import React, { useEffect, useState } from "react";
import TableGrid from "../../../../components/UI/TableGrid";
import { PDFDocument } from "pdf-lib";
import StateFormConfifService from "../../../../services/StateFormsConfifService";
import FileManagerService from "../../../../services/FileManagerService";
import WithDropdownState from "../../../../hoc/WithDropdownState";
import withReduxState from "../../../../hoc/wReduxState";
import WithRoutify from "../../../../hoc/WithRoutify";

const FormsTab = ({ visit_id,...props }) => {
  const [documentsList, setDocumentsList] = useState({
    tableHeaders: [],
    tableRows: { data: [] },
  });
  const [error, setError] = useState("");

  const getTableHeaders = () => [
    { label: "State", key: "state", type: "" },
    { label: "Form", key: "state_form_name", type: "" },
    { label: 'Action',key:'action',type:'Actions'},
  ];

  const fetchForms = async () => {
    
    try {
      props.Loader(true);
      const res = await StateFormConfifService.getFormByState(visit_id);
      if (res.status === "SUCCESS" && Array.isArray(res.data)) {
        const tableData = res.data.map((item) => ({
          rowId: item.form_id,
          data: {
            state: item.state || "-",
            // state_form_name:{value:(
            //     <span
            //       className="text-primary"
            //       style={{ cursor: "pointer", textDecoration: "underline" }}
            //       onClick={() => downloadFormHandler(item.form_id,item.state_form_name)}
            //     >
            //       {item.state_form_name}
            //     </span>
            //   )} ,
            state_form_name: item.state_form_name||"-",
            action: [    
              {
                className: "btn px-0",      
                iconType:"Download",
                title: "Download PDF",
                iconColor:'#000',
                iconDropDownList:[{
                  label:'Edit & Print PDF',
                  clickHandler:()=>downloadFormHandler(item.form_id,item.state_form_name,'EDIT')
              },
              {
                  label:'Print PDF',
                  clickHandler:()=>downloadFormHandler(item.form_id,item.state_form_name,'NON_EDIT')              }]
             }
          ],
          },
        }));

        setDocumentsList({
          tableHeaders: getTableHeaders(),
          tableRows: { data: tableData },
        });
      } else {
        setError("No forms found or invalid response.");
      }
    } catch (err) {
      console.error("Error fetching form list:", err);
      setError("Failed to fetch form list.");
    }finally{
      props.Loader(false);
    }
  };

  const downloadFormHandler = async (form_id, state_form_name, type) => {
    try {
      props.Loader(true);
      const res = await StateFormConfifService.downloadFilledForm(form_id, visit_id);
      console.log("filled pdf res", res);
  
      if (res?.status === "SUCCESS" && res.data?.file) {
        const { file, ...fieldValues } = res.data;
  
        // Convert base64 to Uint8Array
        const binaryString = window.atob(file);
        const uint8Array = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          uint8Array[i] = binaryString.charCodeAt(i);
        }
  
        const pdfDoc = await PDFDocument.load(uint8Array, { ignoreEncryption: true });
        const form = pdfDoc.getForm();
  
        // Fill fields
        Object.entries(fieldValues).forEach(([key, value]) => {
          try {
            const field = form.getFieldMaybe(key);
            if (!field) {
              console.warn(`Field '${key}' not found in the form.`);
              return;
            }
  
            const fieldType = field.constructor.name;
            const stringValue = value?.toString() ?? "";
  
            switch (fieldType) {
              case "PDFTextField":
                field.setText(stringValue);
                break;
  
              case "PDFCheckBox":
                if (value === true || value === "Yes" || value === "1" || value === 1) {
                  field.check();
                } else {
                  field.uncheck();
                }
                break;
  
              case "PDFDropdown":
                try {
                  const options = field.getOptions();
                  const normalizedValue = stringValue.trim();
                  if (options.includes(normalizedValue)) {
                    field.select(normalizedValue);
                  } else {
                    console.warn(`Dropdown '${key}' does not support value '${normalizedValue}'. Options: ${options.join(", ")}`);
                  }
                } catch (e) {
                  console.warn(`Error selecting dropdown '${key}':`, e);
                }
                break;
  
              case "PDFRadioGroup":
                try {
                  const options = field.getOptions();
                  if (options.includes(stringValue)) {
                    field.select(stringValue);
                  } else {
                    console.warn(`Radio group '${key}' does not support value '${stringValue}'`);
                  }
                } catch (e) {
                  console.warn(`Error selecting radio group '${key}':`, e);
                }
                break;
  
              default:
                console.warn(`Unsupported field type: ${fieldType} for key '${key}'`);
            }
          } catch (e) {
            console.warn(`Error setting field '${key}':`, e.message);
          }
        });
  
        // Flatten if requested
        if (type === "NON_EDIT") {
          form.flatten();
        }
  
        // Save filled PDF
        const filledPdfBytes = await pdfDoc.save();
  
        // Convert to base64 for printPdf
        const base64String = btoa(
          filledPdfBytes.reduce((data, byte) => data + String.fromCharCode(byte), "")
        );
  
        const pdfData = {
          file_content: base64String,
          original_name: `${state_form_name}_${type}.pdf`,
          mime_type: "application/pdf",
        };
  
        FileManagerService.printPdf(pdfData);
      } else {
        alert("Invalid response or missing PDF file.");
      }
    } catch (err) {
      console.error("Error downloading or filling the form:", err);
      alert("Failed to download and fill the form.");
    }finally{
      props.Loader(false);
    }
  };
  

  useEffect(() => {
    if (visit_id) fetchForms();
  }, [visit_id]);

  return (
      <div className="sh_innerPortview">

          <div className="col-12 p-1">
            <div className="sh_cardBox  shadow-none  border mb-0" style={{ height: "680px" }}>
              <div className="sh_cardHeader">
                <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                  <h6 className="text-md mb-0">Configured State Forms</h6>
                </div>
              </div>
              <div
                  className="sh_cardBody p-0"
                  >
                <TableGrid {...documentsList} />
              </div>
            </div>
          </div>
        </div>

  );
};

export default WithDropdownState(withReduxState(WithRoutify(FormsTab)));
